import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

import classNames from 'classnames';

import styles from './ImageGridOverflowOverlay.scss';

interface OverflowOverlayProps {
  imagesInOverflow?: number;
  className?: string;
}

const ImageGridOverflowOverlay: FunctionComponent<OverflowOverlayProps> = ({
  imagesInOverflow,
  className,
}) => {
  const { t } = useTranslation('common', { useSuspense: false });

  if (typeof imagesInOverflow === 'undefined' || imagesInOverflow === 0) {
    return null;
  }

  return (
    <div className={classNames(styles.block, className)}>
      <span aria-label={t('timeline.moreImages')} className={styles.text}>
        +{imagesInOverflow}
      </span>
    </div>
  );
};

export default ImageGridOverflowOverlay;
